import type { Load } from '@sveltejs/kit';

export const csr = true;
export const prerender = true;

export const _CourseDetailVariables: Load = ({ params }) => {
	return {
		slug: params.slug ? params.slug : ''
	};
};
